import React from "react";

export default function ClassHeader(props) {

    function getJudges() {
        const judges = []

        for (const judge of props.related_data.judges) {
            if (!judge.name) continue

            let judgeName = "";
            if (judge.position) {
                judgeName = judge.position + ": "
            }
            judgeName += judge.name.replace(",", " ")

            if (judge.iscoursedesigner) judgeName += ' (Course Designer)'
            else if (judge.isjudge) judgeName += ' (Judge)'

            if (judgeName)
                judges.push(judgeName);
        }
        return judges.join(", ");
    }

  return (
    <div>
      <h2 className='sgl-h2'>
        Class {props.class_details.number} - {props.class_details.name}
      </h2>
      {props.jumper_table_info &&
      props.class_details.class_type == "Jumpers" ? (
        <p className='sgl-p'>
          <span className='grid-heading class_jumper_table'>
            {props.jumper_table_info.jumper_table}
          </span>
        </p>
      ) : (
        <p className='sgl-p'>
          <span className='grid-heading class_jumper_table'>
            {props.related_data.hunter_type}
          </span>
        </p>
      )}
      {props.class_details.sponsor && (
        <h3 className='sponsor_text sgl-h3'>
          Sponsored By: {props.class_details.sponsor}
        </h3>
      )}
      {props.related_data.judges_count > 0 && (
        <p className='sponsor_text sgl-h3'>Officials: {getJudges()}</p>
      )}

      <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div>
      <br />
    </div>
  );
}
